<template>
  <div class="tw:px-4 tw:py-2 tw:flex tw:gap-2">
    <slot />
  </div>
</template>

<script setup>
</script>
